import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FolderContent, IFolder } from '../../models/resource';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  private readonly http = inject(HttpClient);
  private readonly baseApiUrl = '/umbraco/management/api/v1/myhubtest';
  private readonly proxiedAssetBasePath = '/umbraco-media';

  getFolders(schoolCode: string): Observable<IFolder[]> {
    return this.http.get<IFolder[]>(`${this.baseApiUrl}/school/${encodeURIComponent(schoolCode)}/library/folders`);
  }

  getFolderResources(folderId: string): Observable<FolderContent[]> {
    return this.http
      .get<FolderContent[]>(`${this.baseApiUrl}/library/folders/${encodeURIComponent(folderId)}/resources`)
      .pipe(map((resources) => resources.map((r) => this.rewriteResourceUrls(r))));
  }

  private rewriteResourceUrls(resource: FolderContent): FolderContent {
    switch (resource.type) {
      case 'Document':
        return { ...resource, documentUrl: this.rewriteAssetUrl(resource.documentUrl) };
      case 'Video': {
        const thumbnailUrl =
          resource.thumbnailUrl ??
          (resource.videoSource === 'youtube' ? `https://img.youtube.com/vi/${resource.videoUrl}/mqdefault.jpg` : '');
        return {
          ...resource,
          videoUrl: resource.videoSource === 'file' ? this.rewriteAssetUrl(resource.videoUrl) : resource.videoUrl,
          thumbnailUrl:
            resource.videoSource === 'file' && thumbnailUrl ? this.rewriteAssetUrl(thumbnailUrl) : thumbnailUrl,
        };
      }
      case 'Photo':
        return { ...resource, imageUrl: this.rewriteAssetUrl(resource.imageUrl) };
    }
  }

  private rewriteAssetUrl(url: string): string {
    if (!url) {
      return url;
    }

    if (/^https?:\/\//i.test(url)) {
      const parsed = new URL(url);
      return `${this.proxiedAssetBasePath}${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    if (url.startsWith('/')) {
      return `${this.proxiedAssetBasePath}${url}`;
    }

    return `${this.proxiedAssetBasePath}/${url}`;
  }
}
